import { useTheme } from "@commonlibs";
import { useMediaQuery } from "@commonlibs";

export default function (): boolean {
    const {
        breakpoints: {
            values: { mobile },
        },
    } = useTheme();

    return useMediaQuery(`(max-width: ${mobile}px)`);
}
